import axios from '@/core/services/axios';

/**
 * Клиент API журнала действий (GET /api/audit_logs).
 *
 * Используется настроенный экземпляр axios (`@/core/services/axios`):
 * он задаёт базовый адрес `api` и подставляет токен доступа в заголовок
 * Authorization. «Сырой» axios из пакета перехватчика не имеет, и запросы
 * к журналу уходили без авторизации — сервер отвечал 401, а страница
 * показывала пустой список.
 */
const BASE = '/audit_logs';

function cleanParams(params) {
  return Object.fromEntries(Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined));
}

export async function getAuditLogs(params) {
  const { data } = await axios.get(BASE, { params: cleanParams(params) });
  return data;
}

export async function getAuditLogFilters() {
  const { data } = await axios.get(`${BASE}/filters`);
  return data;
}

/**
 * Адрес выгрузки CSV. Запрос выполняется через AngularJS `$http`, который
 * базовый адрес не подставляет, поэтому путь указывается полностью.
 */
export function buildExportUrl(params) {
  const query = new URLSearchParams(cleanParams(params)).toString();
  return `api/audit_logs/export${query ? `?${query}` : ''}`;
}

/* @ngInject */
export function AuditLogService($async, $http, FileSaver) {
  return {
    logs: (params) => $async(() => getAuditLogs(params)),
    filters: () => $async(getAuditLogFilters),
    exportCsv: (params) =>
      $async(async () => {
        const response = await $http.get(buildExportUrl(params), { responseType: 'blob' });
        FileSaver.saveAs(response.data, `audit-log-${new Date().toISOString().slice(0, 10)}.csv`);
      }),
  };
}
